// extracted by mini-css-extract-plugin
module.exports = {"bgPosition":"Intro_bgPosition__1ALZR","box":"Intro_box__2Y5VG","overlay":"Intro_overlay__2p6JX"};